// import Lang from '../../common/Lang';
import Mood from '../../common/Mood';
import { MainStayled } from './styled';
const Toggle = () => {
  return (
    <MainStayled >
      <Mood/>
      {/* <Lang/> */}
    </MainStayled>
  )
}

export default Toggle